<div class="component-heading h-n-80 p-lr-30 flex flex-row justify-start items-center">
  Add Contact
</div>
<div class="action-heading h-n-50 p-lr-30 flex flex-row justify-between items-center">
  <a class="link-color" (click)="onCancelAddContact()"
     particleAnalytics
     analyticsCategory="share-items-dialog"
     analyticsAction="cancel-btn">Cancel</a>
  <a class="link-color"
     [ngClass]="{'disable': !addContactDetails || addContactDetails?.status?.toLowerCase() === 'invalid'}"
     (click)=onAddContact()
     particleAnalytics
     analyticsCategory="add-contact"
     analyticsAction="done-btn">
    Done
  </a>
</div>
<particle-add-contact-form (contactDetails)="onContactValueChanged($event)"
                           class="flex flex-col full-grow-no-shrink-no-basis"></particle-add-contact-form>
